import { render } from "./ProfilePageRework.vue?vue&type=template&id=2f45e9e4&scoped=true"
import script from "./ProfilePageRework.vue?vue&type=script&lang=js"
export * from "./ProfilePageRework.vue?vue&type=script&lang=js"

import "./ProfilePageRework.vue?vue&type=style&index=0&id=2f45e9e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f45e9e4"]])

export default __exports__